import { createApi } from "@reduxjs/toolkit/query/react";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { FetchArgs, FetchBaseQueryArgs, FetchBaseQueryMeta } from "@reduxjs/toolkit/dist/query/fetchBaseQuery";
import { BaseQueryFn } from "@reduxjs/toolkit/dist/query/baseQueryTypes";
import { fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { v4 as uuidv4 } from "uuid";

export enum TagTypes {}

export const apiBase = createApiBase(Object.values(TagTypes).map((t) => t.valueOf()));

function createApiBase<T extends string>(tagTypes?: T[]) {
    return createApi({
        baseQuery: apiBaseQuery({ baseUrl: "/rest/subscriber-feedback" }),
        tagTypes: [...(tagTypes ?? [])],
        endpoints: () => ({}),
    });
}

export type ApiError = FetchBaseQueryError & {
    id: string;
};

export function apiBaseQuery(
    args: FetchBaseQueryArgs,
): BaseQueryFn<string | FetchArgs, unknown, ApiError, {}, FetchBaseQueryMeta> {
    const baseQuery = fetchBaseQuery(args);

    return async (args, api) => {
        const result = await baseQuery(args, api, {});
        if (result.error !== undefined) {
            return { ...result, error: { ...result.error, id: uuidv4() } };
        }

        return result;
    };
}
